























import {Vue, Component, Prop} from 'vue-property-decorator';
import ApiConnector from '@/services/ApiConnector';
import FileUploadStatus from '@/enums/FileUploadStatus';
import Directory from '@/model/Directory';

@Component
export default class FileUploader extends Vue {
	private FileUploadStatus = FileUploadStatus;
	private apiConnector: ApiConnector = null;

	@Prop()
	private currentDirectory: Directory;

	@Prop()
	private acceptedFileTypes: string[];

	private uploadInProgress: boolean = false;
	private uploadPercentage: number = 0;
	private uploadStatus: FileUploadStatus = null;

	constructor()
	{
		super();

		this.apiConnector = new ApiConnector();
	}

	public onDrop(transferData: any, nativeEvent: DragEvent)
	{
		const items: DataTransferItemList = nativeEvent.dataTransfer.items;

		if (items.length)
		{
			const files: SystemFile[] = [];

			for (const item of items)
			{
				files.push(item.getAsFile());
			}

			this.uploadInProgress = true;
			this.uploadStatus = FileUploadStatus.InProgress;
			this.apiConnector.upload(this.currentDirectory, files, this.onFileUploadProgress).then(this.onFileUploadFinished).catch(this.onFileUploadFinished);
		}
	}

	public onFilesChanged(event: Event)
	{
		const target: HTMLInputElement = event.target as HTMLInputElement;
		const files: SystemFile[] = [];

		for (const file of target.files)
		{
			files.push(file);
		}

		this.uploadInProgress = true;
		this.uploadStatus = FileUploadStatus.InProgress;
		this.apiConnector.upload(this.currentDirectory, files, this.onFileUploadProgress).then(this.onFileUploadFinished).catch(this.onFileUploadFinished);
	}

	public onFileUploadProgress(event: ProgressEvent)
	{
		const uploaded = event.loaded;
		const total = event.total;

		this.uploadPercentage = (uploaded / total) * 100;
	}

	public onFileUploadFinished(success: boolean)
	{
		if (success)
		{
			this.uploadStatus = FileUploadStatus.Success;
		}
		else
		{
			this.uploadStatus = FileUploadStatus.Failed;
		}

		setTimeout(() => {
			const fileInput = this.$refs.fileInput as HTMLInputElement;

			this.uploadInProgress = false;
			this.uploadPercentage = 0;
			fileInput.value = '';
		}, 750);
	}
}
